import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const API = 'https://admin.bridge365.in/wp-json/wc/v3';
const CK = "ck_1d0bfb52b9046a39fb2d906f89f691968931bce6";
const CS = "cs_956c51f2c9249f343bec7f0ecbfd7738654ba424";
const CATEGORY_ID = 25;

function Bestsellerproduct() {
  const [products, setProducts] = useState([]);
  const sliderRef = useRef(null);

  useEffect(() => {
    fetch(
      `${API}/products?category=${CATEGORY_ID}&per_page=10&orderby=date&order=desc&consumer_key=${CK}&consumer_secret=${CS}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setProducts(data);
          return;
        }

        console.error("Unexpected API response:", data);
        setProducts([]);
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        setProducts([]);
      });
  }, []);

  const settings = {
    dots: false,
    infinite: products.length > 5,
    autoplay: products.length > 1,
    autoplaySpeed: 2500,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="container fea-products-container bestseller-products">
      <div className="sec-title">
        <h2>Featured Products</h2>
        <div className="separator"></div>
      </div>

      <div className="bestseller-slider-area">
        <button
          type="button"
          onClick={() => sliderRef.current?.slickPrev()}
          className="bestseller-arrow bestseller-arrow-prev"
          aria-label="Previous products"
        >
          <FiChevronLeft />
        </button>

        <button
          type="button"
          onClick={() => sliderRef.current?.slickNext()}
          className="bestseller-arrow bestseller-arrow-next"
          aria-label="Next products"
        >
          <FiChevronRight />
        </button>

        <div className="bestseller-slider">
          <Slider ref={sliderRef} {...settings}>
            {products.map((item) => (
              <div key={item.id} className="bestseller-slide">
                <article className="bestseller-card">
                  <Link to={`/product/${item.id}`} className="bestseller-link">
                    <div className="bestseller-image-wrap">
                      <img
                        src={item.images?.[0]?.src || "/no-image.png"}
                        alt={item.name}
                        className="bestseller-image"
                      />
                    </div>

                    <h4 className="bestseller-title">{item.name}</h4>
                  </Link>
                </article>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}

export default Bestsellerproduct;
